module.exports = __webpack_public_path__ + "img/xinnengyuan.4b7694e7.png";